import { useTheme } from "@mui/material/styles";
export var TextAreaStyles = function () {
    var theme = useTheme();
    return {
        wrapper: {
            padding: "14px 16px",
            borderRadius: "8px",
            borderColor: theme.palette.grey[200],
            fontSize: "14px",
            fontFamily: "Roboto, sans-serif",
            color: theme.palette.grey[700],
        },
    };
};
